import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Button, Table, Input, List, Checkbox, Modal, Slider,Spin, Steps } from 'antd';
import { FaSearch } from 'react-icons/fa';
import '../../css/VesselAutoPooling.css';
import { ArrowRightOutlined,RocketOutlined, HourglassOutlined, FileSyncOutlined, CheckCircleOutlined } from '@ant-design/icons';
import closeIcon from "../../assets/icons/auto-pooling/close.svg";
import rocketIcon from "../../assets/icons/pooling/rocket.svg";
import GeneratedPools from '../../components/AutoPooling/GeneratedPools';
import CommonHeader from '../../components/HeaderComponent/CommonHeader';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchPoolingMetrics, fetchVesselDetailsTable } from '../../features/VesselDetails/VesselDetailsSlice';
import { generateAutoPool } from '../../features/AutoPooling/AutoPoolingSlice';
import cbRedIcon from "../../assets/icons/pooling/cb-red.svg"
import cbGreenIcon from "../../assets/icons/pooling/cb-green.svg"
import { FormLabel } from '@mui/material';

const { TabPane } = Tabs;

const vesselStatusIcons = {
  "Pending User Approval": <HourglassOutlined />,
  "Admin Pending": <FileSyncOutlined />,
  "Admin Approved": <CheckCircleOutlined />,
};

const vesselStatusColors = {
  "Pending User Approval": "#1890FF", // Blue
  "Admin Pending": "#FFC107", // Yellow
  "Admin Approved": "#52C41A", // Green
};

const vesselStatusMeanings = {
  "Pending User Approval": "Pending Member Approval", // Blue
  "Admin Pending": "Pending Admin Approval", // Yellow
  "Admin Approved": "Admin Approved", // Green
};

const VesselAutoPooling = () => {
  const tableRef = useRef(null);

  const [activeTab, setActiveTab] = useState('surplus');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [generatedPoolResult, setGeneratedPoolResult] = useState(null);
  const [lowerPrice, setLowerPrice] = useState(0);
  const [upperPrice, setUpperPrice] = useState(640);
  const [activePoolIndex, setActivePoolIndex] = useState(0);
  const [isExpectedPriceModalVisible, setIsExpectedPriceModalVisible] = useState(false);
  const [selectedVessels, setSelectedVessels] = useState({
    surplus: [],
    deficit: []
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [filterModal, setFilterModal] = useState(false);
  const dispatch = useDispatch();
  const { vesselDetailsTableData, metrics } = useSelector((state) => state.vesselDetails);
  const { status } = useSelector((state) => state.autoPooling);
  const [filteredVessels, setFilteredVessels] = useState({
    surplus: vesselDetailsTableData.filter((item)=>item.cb_wants_to_sell>=0),
    deficit: vesselDetailsTableData.filter((item)=>item.cb_wants_to_sell<0),
  });
  const navigate = useNavigate();
  const [selectedSurplusValue,setSelectedSurplusValue] = useState(0);
  const [selectedDeficitValue,setSelectedDeficitValue] = useState(0);
  const [parentMinHeight, setParentMinHeight] = useState('47vh');
  const [parentflextype, setparentflextype] = useState('flex-start');
  const [parentmargin, setparentmargin] = useState('flex-start');

  const [tableHeight, setTableHeight] = useState(window.innerHeight);
  useEffect(() => {
    const handleResize = () => {
      setTableHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const minHeight = 600;
  const maxHeight = 2160;
  const minScroll = 54.5; // in vh
  const maxScroll = 90;

  const scrollY = Math.min(
    maxScroll,
    Math.max(minScroll, ((tableHeight - minHeight) / (maxHeight - minHeight)) * (maxScroll - minScroll) + minScroll)
  );


  useEffect(() => {
    const tableHeight = tableRef.current?.offsetHeight || 0;
    setParentMinHeight(tableHeight < window.innerHeight * 0.545 ? '54.5vh' : `${tableHeight}px`);
    setparentflextype(tableHeight < window.innerHeight * 0.545 ? 'flex-start' : `flex-start`);
    setparentmargin(tableHeight < window.innerHeight * 0.545 ? '1vh' : `0vh`);
  }, [vesselDetailsTableData, metrics]);

  // useEffect(()=>{
  //   const inkBar = document.querySelector('.ant-tabs-ink-bar');
  //   inkBar.style.backgroundColor = "#0CC876";

  // },[])


  useEffect(() => {

    const filterParams = {
      requested_vessel_type: 'my_vessels',
      // requested_vessel_type: '',
    };

    dispatch(fetchPoolingMetrics(filterParams));
    dispatch(fetchVesselDetailsTable(filterParams));

  }, [dispatch, activeTab]);

  useEffect(() => {
    const selectedVesselsInTab = selectedVessels[activeTab] || [];
  
    const totalCB = Math.abs(
      selectedVesselsInTab.reduce(
        (sum, vessel) => sum + (vessel.cb_wants_to_sell || 0),
        0
      ) / 10 ** 6
    );
  
    if (activeTab === "surplus") {
      setSelectedSurplusValue(totalCB);
    } else if (activeTab === "deficit") {
      setSelectedDeficitValue(totalCB);
    }
  }, [selectedVessels, activeTab]);
  

  useEffect(() => {
    const vessels = vesselDetailsTableData || [];
    if (searchTerm) {
      setFilteredVessels({
        surplus: vessels.filter((item) => 
          item.cb_wants_to_sell >= 0 &&
          (item.imo_number.includes(searchTerm.toLowerCase()) ||
           item.vessel_name.toLowerCase().includes(searchTerm.toLowerCase()))
        ),
        deficit: vessels.filter((item) => 
          item.cb_wants_to_sell < 0 &&
          (item.imo_number.includes(searchTerm.toLowerCase()) ||
           item.vessel_name.toLowerCase().includes(searchTerm.toLowerCase()))
        ),
      });
    }
     else {
      setFilteredVessels({
        surplus: vessels
          .filter((item) => item.cb_wants_to_sell >= 0)
          .sort((a, b) => (b.active_for_pooling - a.active_for_pooling)),  
        deficit: vessels
          .filter((item) => item.cb_wants_to_sell < 0)
          .sort((a, b) => (b.active_for_pooling - a.active_for_pooling)), 
      });
      
    }
  }, [searchTerm, vesselDetailsTableData]);

  const handleExpectedPriceModal= () =>{
    const imo_numbers = fetchAllImoNumbers(selectedVessels);
    console.log("imojfhfjhdfk",imo_numbers,imo_numbers.length==1)
    if(imo_numbers.length==1){
      const expected_price_hv = "";
      const expected_price_lv = "";
      handleGeneratePool(expected_price_lv,expected_price_hv);
    } else{
      setIsExpectedPriceModalVisible(true);
    }
  }

  const onSliderChange = (values) => {
    setLowerPrice(values[0]);
    setUpperPrice(values[1]);
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    setSearchTerm('');
    // const inkBar = document.querySelector('.ant-tabs-ink-bar');
    // if (inkBar) {
    //   if (key === "surplus") {
    //     inkBar.style.backgroundColor = "#0CC876";
    //   } else if (key === "deficit") {
    //     inkBar.style.backgroundColor = "#FB2F2F";
    //   }
    // }

  };

  const handleSelectAll = (e) => {
    const allVessels = filteredVessels[activeTab].filter((item) => item.active_for_pooling==true); // Use the filtered list for selecting all
    if (e.target.checked) {
      setSelectedVessels((prevSelected) => ({
        ...prevSelected,
        [activeTab]: allVessels,
      }));
    } else {
      setSelectedVessels((prevSelected) => ({
        ...prevSelected,
        [activeTab]: [],
      }));
    }
  };

  const handleSelectVessel = (vessel) => {
    setSelectedVessels((prevSelected) => {
      const newSelected = [...prevSelected[activeTab]];
      const isSelected = newSelected.some((selected) => selected.imo_number === vessel.imo_number);
      if (isSelected) {
        return {
          ...prevSelected,
          [activeTab]: newSelected.filter((selected) => selected.imo_number !== vessel.imo_number),
        };
      } else {
        return {
          ...prevSelected,
          [activeTab]: [...newSelected, vessel],
        };
      }
    });
  };

  const handleClose = () => {
    setSelectedVessels(prevSelected => ({
      ...prevSelected,
      ['surplus']: [],
      ['deficit']: []
    }));
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setActivePoolIndex(0);
  }

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleViewDetails = (row) => {
    const data = row;
    let type;

    if (data.is_my_vessel == true) {
      type = "edit";
    } else {
      type = "view";
    }
    console.log("type", type)
    navigate('/OnBoarding', { state: { rowData: data, type: type } });
  };

  const fetchAllImoNumbers = (vessels) => {
    const imoNumbers = [];
    Object.keys(vessels).forEach(key => {
        if (Array.isArray(vessels[key])) {
            vessels[key].forEach(vessel => {
                if (vessel.imo_number) {
                    imoNumbers.push(vessel.imo_number);
                }
            });
        }
    });
    return imoNumbers;
};


  const handleGeneratePool = async (expected_price_lv,expected_price_hv)=>{
    if(isExpectedPriceModalVisible){
      setIsExpectedPriceModalVisible(false);
    }
    const imo_numbers = fetchAllImoNumbers(selectedVessels);

    const result = await dispatch(generateAutoPool({imo_number:imo_numbers,expected_price_hv:expected_price_hv,expected_price_lv:expected_price_lv}));
    setGeneratedPoolResult(result);
    setIsModalVisible(true);

  };

  const columns_surplus = [
    {
      title: (
        <Checkbox
          className="select-all-btn custom-auto-pooling-checkbox"
          onChange={handleSelectAll}
          checked={
            filteredVessels[activeTab].filter((item) => item.active_for_pooling == true).length > 0 &&
            selectedVessels[activeTab].length === filteredVessels[activeTab].filter((item) => item.active_for_pooling == true).length
          }
        >
          {console.log("selectedVessels[activeTab]", selectedVessels[activeTab].length, filteredVessels[activeTab].length)}
        </Checkbox>
      ),
      align: "center",
      dataIndex: "select",
      render: (_, vessel) => (
        <Checkbox
          className="custom-auto-pooling-single-checkbox"
          checked={selectedVessels[activeTab].filter((item) => item.active_for_pooling == true).some(
            (selected) => selected.imo_number == vessel.imo_number
          )}
          onChange={() => handleSelectVessel(vessel)}
        />
      ),
      width: 50,
    },
    {
      title: <div style={{ textAlign: "center", width: "100%" }}>Token ID</div>,
      dataIndex: "token_id",
      key: "token_id",
      align: "left", // left align value
    },
    {
      title: <div style={{ textAlign: "center", width: "100%" }}>IMO Number</div>,
      dataIndex: "imo_number",
      key: "imo_number",
      align: "left", // left align value
    },    
    {
      title: "Compliance Balance",
      dataIndex: "cb_wants_to_sell",
      key: "cb",
      align: "center",
      render: (value) => (
        <span className="left-align left-margin cb-surplus flex-center" style={{ display: "flex",justifyContent:"center", alignItems: "center" }}>
          {/* <img width={25} src={cbGreenIcon} alt="CB Icon" /> */}
          {(Math.floor((value / 10 ** 6) * 1000000) / 1000000).toFixed(6) || "N/A"}
        </span>
      ),
    },
    {
      title: <span>Penalty <br /> (€)</span>,
      dataIndex: "penalty",
      key: "penalty",
      align: "center",
      width: 100,
      render: (value) => <span style={{ color: "#FB2F2F", textAlign: "center" }}>{value}</span>,
    },
    {
      title: <span>Expected Price <br /> (€/MT CO₂e)</span>,
      dataIndex: "expected_price_lv",
      key: "expected_price",
      align: "center",
      render: (_, vessel) => (
        <span style={{ color: "#678DFF", textAlign: "center" }}>
          {`${vessel.expected_price_lv} - ${vessel.expected_price_uv}` || "N/A"}
        </span>
      ),
    },
    {
      title: "GHGIE",
      dataIndex: "ghg_intensity",
      key: "ghgie",
      align: "center",
      render: (value) => <span style={{ color: "#678DFF" }}>{value || "N/A"}</span>,
    },
    {
      title: "Vessel Status",
      key: "vessel_status",
      align: "center",
      width: 200,
      render: (_, vessel) => {
        const currentStageIndex = ["Pending User Approval", "Admin Pending", "Admin Approved"].indexOf(vessel.vessel_status);
  
        return (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1vh" }}>
            {["Pending User Approval", "Admin Pending", "Admin Approved"].map((step, index) => {
              const isCompleted = index <= currentStageIndex;
              return (
                <React.Fragment key={index}>
                  <div
                    style={{
                      fontSize: "20px",
                      color: isCompleted ? vesselStatusColors[step] : "#d9d9d9",
                    }}
                  >
                    {vesselStatusIcons[step]}
                  </div>
                  {index < 2 && (
                    <div
                      style={{
                        width: "40px",
                        height: "4px",
                        backgroundColor: isCompleted ? vesselStatusColors[step] : "#d9d9d9",
                        borderRadius: "2px",
                      }}
                    />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        );
      },
    },
  ];
  const columns_deficit = [
    {
      title: (
        <Checkbox
          className="select-all-btn custom-auto-pooling-checkbox"
          onChange={handleSelectAll}
          checked={
            filteredVessels[activeTab].filter((item) => item.active_for_pooling == true).length > 0 &&
            selectedVessels[activeTab].length === filteredVessels[activeTab].filter((item) => item.active_for_pooling == true).length
          }
        />
      ),
      dataIndex: "select",
      render: (_, vessel) => (
        <Checkbox
          className="custom-auto-pooling-single-checkbox"
          checked={selectedVessels[activeTab].some(
            (selected) => selected.imo_number === vessel.imo_number
          )}
          onChange={() => handleSelectVessel(vessel)}
        />
      ),
      width: 50,
      align: "center",
    },
    {
      title: <div style={{ textAlign: "center", width: "100%" }}>Token ID</div>,
      dataIndex: "token_id",
      key: "token_id",
      align: "left",
    },
    {
      title: <div style={{ textAlign: "center", width: "100%" }}>IMO Number</div>,
      dataIndex: "imo_number",
      key: "imo_number",
      align: "left",
    },
    {
      title: <div style={{ textAlign: "center", width: "100%" }}>Compliance Balance</div>,
      dataIndex: "cb_wants_to_sell",
      key: "cb",
      align: "center",
      render: (value) => (
        <span className="left-align left-margin cb-deficit flex-center" style={{ display: "flex",justifyContent:"center", alignItems: "center" }}>
          {/* <img width={25} src={cbRedIcon} alt="CB Icon" /> */}
          {(Math.floor((value / 10 ** 6) * 1000000) / 1000000).toFixed(6) || "N/A"}
        </span>
      ),
    },
    {
      title: <div style={{ textAlign: "center", width: "100%" }}>Penalty <br /> (€)</div>,
      dataIndex: "penalty",
      key: "penalty",
      width: 100,
      align: "center",
      render: (value) => <span style={{ color: "#FB2F2F", textAlign: "center" }}>{value}</span>,
    },
    {
      title: <div style={{ textAlign: "center", width: "100%" }}>Expected Price <br /> (€/MT CO₂e)</div>,
      dataIndex: "expected_price_lv",
      key: "expected_price",
      align: "center",
      render: (_, vessel) => (
        <span style={{ color: "#678DFF", textAlign: "center" }}>
          {`${vessel.expected_price_lv} - ${vessel.expected_price_uv}` || "N/A"}
        </span>
      ),
    },
    {
      title: <div style={{ textAlign: "center", width: "100%" }}>GHGIE</div>,
      dataIndex: "ghg_intensity",
      key: "ghgie",
      align: "center",
      render: (value) => <span style={{ color: "#678DFF" }}>{value || "N/A"}</span>,
    },
    {
      title: <div style={{ textAlign: "center", width: "100%" }}>Vessel Status</div>,
      key: "vessel_status",
      align: "center",
      render: (_, vessel) => {
        const currentStageIndex = ["Pending User Approval", "Admin Pending", "Admin Approved"].indexOf(vessel.vessel_status);
  
        return (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1vh" }}>
            {["Pending User Approval", "Admin Pending", "Admin Approved"].map((step, index) => {
              const isCompleted = index <= currentStageIndex;
              return (
                <React.Fragment key={index}>
                  <div
                    style={{
                      fontSize: "20px",
                      color: isCompleted ? vesselStatusColors[step] : "#d9d9d9",
                    }}
                  >
                    {vesselStatusIcons[step]}
                  </div>
                  {index < 2 && (
                    <div
                      style={{
                        width: "40px",
                        height: "4px",
                        backgroundColor: isCompleted ? vesselStatusColors[step] : "#d9d9d9",
                        borderRadius: "2px",
                      }}
                    />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        );
      },
    },
  ];
  

  const items = [
    {
      label:  <span className="custom-tab surplus-tab">
                Surplus vessels <br/>{selectedVessels.surplus.length}/{metrics?.cb_my_vessels_surplus_vessels_count} Selected
              </span>,
      key: 'surplus',
      className:'tabs-table',
      children:  <Table
                  ref={tableRef}
                  className="autopool-list bordered-table"
                  columns={columns_surplus}
                  dataSource={filteredVessels[activeTab]}
                  rowKey="imo_number"
                  rowClassName={(record) => {
                    const isSelected = selectedVessels[activeTab].some(
                      (selected) => selected.imo_number === record.imo_number
                    );

                    const isDisabled = record.active_for_pooling === false; // Directly check the record property

                    return `${isDisabled ? "disabled-row" : ""} ${
                      isSelected ? "selected-row" : ""
                    }`.trim();
                  }}
                  pagination={false}
                  scroll={{ y: `${scrollY}vh` }}
                  bordered
                />
    },
    {
      label:<span className="custom-tab deficit-tab">
              Deficit vessels <br/> {selectedVessels.deficit.length}/{metrics?.cb_my_vessels_deficit_vessels_count || 0} Selected
            </span>,
      key: 'deficit',
      className:'tabs-table',
      children: <Table
                  ref={tableRef}
                  className="autopool-list bordered-table"
                  columns={columns_deficit}
                  dataSource={filteredVessels[activeTab]}
                  rowKey="imo_number"
                  rowClassName={(record) => {
                    const isSelected = selectedVessels[activeTab].some(
                      (selected) => selected.imo_number === record.imo_number
                    );

                    const isDisabled = record.active_for_pooling === false; // Directly check the record property

                    return `${isDisabled ? "disabled-row" : ""} ${
                      isSelected ? "selected-row" : ""
                    }`.trim();
                  }}
                  pagination={false}
                  scroll={{ y: `${scrollY}vh` }}
                  bordered
                />
    }
  ];


  return (
    <div className="auto-pool-container">
      <CommonHeader headerKey="auto_pooling_screen" headerTitle="Vessel Auto Pooling" headerSubTitle="Select Vessels to participate in the auto pooling process." selectedSurplusValue={selectedSurplusValue} selectedDeficitValue={selectedDeficitValue} />
      
      {/* Common Actions for both tabs */}
       {/*<div className="auto-pool-actions">
        <div className='auto-pool-actions-left'>
        
        </div>
        <div className='auto-pool-actions-right'>
          <Button className="auto-pool-filter" onClick={() => setFilterModal(true)}>
            <span className="auto-pool-filter-text">Filters</span>
          </Button>
        </div>
      </div> */}
      
      <div className='auto-pool-body'>
        
        <Tabs
          defaultActiveKey="surplus"
          className='tab-main'
          onChange={handleTabChange}
          items={items}
          style={{ height: "20vh" }}
          tabBarStyle={{ border: "none", display: "flex", gap: "10px" }}
          tabBarExtraContent={{
            right: (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "0.4vw",
                }}
              >
                {(selectedVessels.surplus.length > 0 || selectedVessels.deficit.length > 0) && (
                    <div className="selected-info">
                      {selectedVessels.surplus.length+selectedVessels.deficit.length} Selected
                      <Button
                        icon={<img src={closeIcon} alt="close" />}
                        shape="circle"
                        className='auto-pooling-close'
                        onClick={handleClose} // Added onClick to unselect vessels
                        style={{ padding: '0' }}
                      />
                    </div>
                  )}
                  
                  <div className="auto-pool-search-container">
                    <FaSearch className="search-icon" style={{ color: "#A4A4A4" }} />
                    <Input
                      type="text"
                      placeholder="Search by IMO or Vessel Name"
                      className="auto-pool-search"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  {<Button
                    className={
                      selectedVessels.surplus.length > 0 || selectedVessels.deficit.length > 0 
                        ? "generate-btn"
                        : "disable generate-btn"
                    }
                    onClick={() => {handleExpectedPriceModal()}}
                  >
                    {/* <img src={rocketIcon} alt="rocket" /> */}
                    Auto Generate Pool
                  </Button>}
              </div>
            ),
          }}
        >
        </Tabs>
        <div className="cb-info">
          <div className='surplus-box surplus'>
            <div className="status-box first">
            <span>Selected Surplus</span>
            <span><img style={{width:'3vh',justifyContent:'center'}} src={cbGreenIcon} alt="cb icon" />{selectedSurplusValue?.toFixed(6)} CB</span>
            </div>
            <div class="slant-line"></div>
            <div className="status-box">
            <span>Total Surplus</span>
            <span><img style={{width:'3vh',justifyContent:'center'}} src={cbGreenIcon} alt="cb icon" />{metrics?.cb_my_vessels_surplus_query?.toFixed(6)} CB</span>
            </div>
          </div>
          <div className='deficit-box deficit'>
            <div className="status-box first">
            <span>Selected Deficit</span>
            <span><img style={{width:'3vh',justifyContent:'center'}} src={cbRedIcon} alt="cb icon" />{Math.abs(selectedDeficitValue)?.toFixed(6)} CB</span>
            </div>
            <div class="slant-line"></div>
            <div className="status-box">
            <span>Total Deficit</span>
            <span><img style={{width:'3vh',justifyContent:'center'}} src={cbRedIcon} alt="cb icon" />{Math.abs(metrics?.cb_my_vessels_deficit_query?.toFixed(6))} CB</span>
            </div>
          </div>
        </div>
      </div>

      <div className='auto-pool-footer'>
        {Object.keys(vesselStatusIcons).map((status) => (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              gap: "0.2vw",
            }}
          >
            {console.log("my name")}
            <div
              key={status}
              style={{
                color: vesselStatusColors[status],
                fontSize: "14px",
              }}
            >
              {vesselStatusIcons[status]}-
            </div>
            <span style={{ color: "#555", fontSize: "15px" }}>
              {vesselStatusMeanings[status]}
            </span>
          </div>
        ))}
      </div>

      {status === "loading" && !isModalVisible ? (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(255, 255, 255, 0.8)",  // White with slight opacity
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999
        }}>
          <Spin size="large" />
        </div>
      ) : isModalVisible && (
        <GeneratedPools
          generatedPoolResult={generatedPoolResult}
          isModalVisible={isModalVisible}
          handleCancel={handleCancel}
          activePoolIndex={activePoolIndex}
          setActivePoolIndex={setActivePoolIndex}
          setIsModalVisible={setIsModalVisible}
        />
      )}


    <Modal
      visible={isExpectedPriceModalVisible}
      onCancel={() => setIsExpectedPriceModalVisible(false)}
      footer={[
        <Button key="ok" type="primary" onClick={()=>handleGeneratePool(lowerPrice,upperPrice)}>
          OK
        </Button>
      ]}
    >
      <div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        </div>

        <div style={{ marginTop: '10px' }}>
          <label>Expected Price Upper Price</label>
          <Input
            type="number"
            value={upperPrice}
            min={lowerPrice + 20} // Ensure upper is always greater than lower
            max={640}
            onChange={(e) => setUpperPrice(Math.min(Math.max(Number(e.target.value), lowerPrice), 640))}
          />
        </div>

        <div style={{ marginTop: '10px' }}>
          <label>Expected Price Lower Price</label>
          <Input
            type="number"
            value={lowerPrice}
            min={0}
            max={upperPrice - 20} // Ensure lower is always less than upper
            onChange={(e) => setLowerPrice(Math.max(Math.min(Number(e.target.value), upperPrice), 0))}
          />
        </div>

        <div style={{ marginTop: '20px' }}>
          <Slider
            range
            min={0}
            max={640}
            step={20}
            value={[lowerPrice, upperPrice]}
            onChange={onSliderChange}
          />
        </div>
      </div>
    </Modal>


    </div>
  );
};

export default VesselAutoPooling;
